import React, { Component } from "react"
import { Image, Button } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import VehicleImage from "../../../images/dashboard/vehicle.svg"
import LockIcon from "../../../images/dashboard/lock-icon.svg"
import LockIconBg from "../../../images/dashboard/warranty.svg"
import BackgroundEllipse from "../../../images/dashboard/bg-ellipse.svg"

class WarrantyPlanCard extends Component {
  render() {
    const { t } = this.props
    return (
      <div className="dashboard-warranty-plan-card">
        <div className="warranty-plan-card-section">
          <div className="warranty-plan-card-text-content">
            <p className="warranty-plan-card-heading">{t("protectYourCarMsg")}</p>
            <Button href="#/WarrantyPlan" className="warranty-plan-card-button">
              {t("checkWarrantyPlansBtn")}
            </Button>
          </div>
          <div className="warranty-card-plan-image">
            <Image className="vehicle-image" src={VehicleImage} />
            <Image className="vehicle-lock-icon" src={LockIcon} />
            <Image className="vehicle-lock-bg-image" src={LockIconBg} />
            <Image className="vehicle-lock-bg-ellipse" src={BackgroundEllipse} />
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation("justForYouCards")(WarrantyPlanCard)
